









import { Component, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { Prefix, SearchType } from '@/types'

@Component({
  components: {}
})
export default class IconBibliography extends ComponentVue {
  @Prop({
    type: String,
    default: Prefix.Real
  })
  prefix!: Prefix

  @Prop({
    type: String,
    default: SearchType.Book
  })
  searchType!: SearchType

  @Prop({
    type: Boolean,
    default: false
  })
  active!: boolean

  get prefixIsSet() {
    return this.prefix === Prefix.Set
  }

  get searchTypeIsT() {
    return this.searchType === SearchType.Book
  }

  get searchTypeIsA() {
    return this.searchType === SearchType.Av
  }

  get searchTypeIsZ() {
    return this.searchType === SearchType.Magazine
  }
}
